import React from 'react';
import { Link } from 'react-router-dom';
import './style/MoreOptions.css';
import {
  ShieldCheck,
  Info,
  Mail,
 
} from 'lucide-react';

import TopNavbar from '../home/TopNavbar';
import TopHeader from '../home/TopHeader';

const MoreOptions = () => {
  const options = [
    // --- Academic & Content ---
    { id: 1, title: 'Privacy Policy', icon: <ShieldCheck size={24} />, color: '#27ae60', path: '/privacy-policy' },
    { id: 2, title: 'About Us', icon: <Info size={24} />, color: '#7f8c8d', path: '/about' },
    { id: 3, title: 'Contact Us', icon: <Mail size={24} />, color: '#1abc9c', path: '/contact' },
  ];

  // ... rest of your component logic


  return (
    <div className="more-options-container">
      <TopNavbar name="More Options" />
      <TopHeader name="More Options" />

      <div className="options-grid">
        {options.map((option) => (
          <Link to={option.path} key={option.id} className="option-link-wrapper">
            <div className="option-card">
              <div className="icon-wrapper" style={{ color: option.color }}>
                {option.icon}
              </div>
              <span className="option-title">{option.title}</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default MoreOptions;